<div class="container text-justify"
  style="width:80%; min-width: 300px; max-width: 900px; top: 150px; position:relative">
  <div class="row pb-5">
    <div class="col-3"></div>
    <div class="col-3"></div>
    <div class="col-3"></div>
    <div class="col-3">
      <button type="button" routerLink="/gitih/pacients" class="btn btn-primary rounded-5 btn-home">
        <i class="fa fa-list fa-5"></i>
        <br>
        Pacients
      </button>
    </div>
  </div>
  <h1>Gestió IT Ingrès Hospitalari</h1>

  <br>
  Projecte pilot promogut pel Servei Català de la Salut, desenvolupat al Parc Taulí per a la gestió de les
  incapacitats
  temporals per ingres hospitalari.
  <br>
  Actualment, als ingressos hospitalaris, el pacient o els familiars han de gestionar les incapacitats temporals des
  d’Atenció Primària.
  Es tracta que es pugui tramitar aquesta gestió des dels propis hospitals. Facilitant i agilitzant el procés de
  gestió
  de les IT.

  <!-- <h3 class="mt-5">Canvis recents</h3>
  
  <div class="alert alert-primary" role="alert">
    <b>4-4-2022</b>
    <ul>
      <li>
        <b>Refrescar fitxa pacient</b>
        <br> 
        Si es demana la recàrrega d'un pacient concret a la fitxa amb la icona <mat-icon>recycling</mat-icon>, 
        es pot després refrescar amb la nova icona <mat-icon>autorenew</mat-icon>, entre les fletxes de anterior - següent, 
        per mostrar les dades recarregades (es convenient esperar uns segons entre la recàrrega i el refresc).
      </li>
    </ul>
  </div>
  <div class="alert alert-primary" role="alert">
    <b>5-3-2022</b>
    <ul>
      <li>
        <b>Motius de rebuig</b>
        <br> 
        Quan es rebutja es demanarà un motiu del rebuig. 
        Si s'informa el motiu 'Altres' caldrà informar alguna observació.
        Si trobeu a faltar algun motiu que es pugui catalogar si us plau ens ho comuniqueu.
      </li>
    </ul>
  </div>
  <div class="alert alert-primary" role="alert">
    <b>21-2-2022</b>
    <ul>
      <li>
        Afegim control PENSIONISTES. En cas d'un pensionista ja es marcarà com REBUTJAT, i es mostrarà
        a la fitxa de detall del pacient (els que actualment ja estan carregats no es marcaran automàticament, només els nous a partir d'ara)
      </li>
      <li>
        Correcció d'error quan es rebutja i s'indiquen dades.
      </li>
    </ul>
  </div>
  <div class="alert alert-primary" role="alert">
    <b>18-2-2022</b>
    <ul>
      <li>
        Afegim PROCEDÈNCIA a les dades del pacient. A la pàgina principal, es pot filtrar per aquest valor.
        Les procedències poden ser: AMB - Ambulatori, HOSP - Hospital, PRO - Programats, URG - Urgències
      </li>
      <li>
        Afegim TELÈFON a les dades del pacient. A la fitxa del pacient es mostra el telèfon. 
        Per no augmentar l'espai ocupat, hem tret la data de naixement, ja que igualment està la edat.
      </li>
    </ul>
  </div>
  <div class="alert alert-primary" role="alert">
    <b>16-2-2022</b>
    <ul>
      <li>
        Quan s'actualitzen les dades no esborra els filtres. Es mantenen els que estan aplicats.
      </li>
      <li>
        Selecció de diagnòstic. En cas que en l'enviament de la IT torni resultat de "Diagnòstic invàlid", 
        es pot canviar per un altre i tornar a enviar. 
      </li>
      <li>
        En l'anul·lació es poden posar observacions i es desen a la vegada que s'anul·la.
      </li>
    </ul>
  </div>
  <div class="alert alert-primary" role="alert">
    <b>7-2-2022</b>
    <ul>
      <li>
        La llista inicial de pacients ja no surt filtrada. Surten tots per facilitar les cerques de pacients concrets.            
      </li>
    </ul>
  </div>
  <div class="alert alert-primary" role="alert"  *ngIf="auth.esAdmin()">
    <b>7-2-2022</b>
    <ul>
      <li>
        (només per administradors) A la llista d'Històrics surten tots els pacients, tant els actuals com els que ja no estan ingressats.
        A l'excel que es demana en aquesta pantalla també surten tots. Els que ja no estan ingressats s'indiquen a l'estat amb aquesta incona 
        (del color que correspongui a l'estat): <mat-icon>speaker_notes_off</mat-icon>
      </li>
    </ul>
    <b>4-2-2022</b>
    <ul>
      <li>
        (només per administradors) Nova opció al menú "Administració" per veure registres "històrics". 
        Son els registres que ja no surten a la llista perquè els pacients ja no estan a l'hospital.
      </li>
      <li>
        (només per administradors) Nova opció per baixar un arxiu Excel amb la llista completa de pacients o de històrics.
        A la barra de filtres, al costat de les opcions de recàrrega i actualització.
      </li>
    </ul>
  </div>
  <div class="alert alert-primary" role="alert">
    <b>28-1-2022</b>
      <ul>
        <li>
          Afegits al detall de dades del pacient el ABS (Àrea Bàsica de Salut) i el CAP (Centre Atenció Primària).
          Per distribuir millor l'espai, la informació de "Estat IT" l'hem passat a la secció dreta.
        </li>
      </ul>
  </div> -->
</div>